import shortly from 'vuex-shortly'
import { GIFTTY_PRODUCTS } from '@store/types'
import graphQL from '@graphQL'
import GifftyProducts from '@graphQL/queries/GifttyProducts'

const state = {
  gifttyProducts: []
}

const getters = {
  [GIFTTY_PRODUCTS]: 'gifttyProducts'
}

const mutations = {
  [GIFTTY_PRODUCTS]: (state, payload) => {
    state.gifttyProducts = payload
  }
}
const actions = {
  [GIFTTY_PRODUCTS]: async ({ commit }) => {
    try {
      await graphQL(GifftyProducts).then(response => {
        if (response.data.data.gifttyCatalog) {
          commit(GIFTTY_PRODUCTS, response.data.data.gifttyCatalog)
        }
      })
      return true
    } catch (error) {
      return false
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/giftty.js